import React from 'react';
import LogoText from "./LogoText";

const CoinyLogo = ({
                       width = 659,
                       height = 470,
                       outerCircleC = 'black',
                       innerCircleC = 'black',
                       largeMuscleC = 'black',
                       innerMuscleC = 'black',
                       upperMuscleC = 'black',
                       coin1c = 'black',
                       coin2c = 'black',
                       coin3c = 'black',
                       coin4c = 'black',
                       coin5c = 'black',
                       isCashTenant = true
                   }) =>
    (
        <svg
            width={width}
            height={height}
            viewBox="15 -10 659 470"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <clipPath id="g">
                    <path
                        style={{
                            stroke: "#000",
                            fill: "#000",
                        }}
                        d="m-23.436 415.074 241.708 1.529-20.652-64.251-63.487-71.9-16.063-43.6-44.364 3.06.765 39.01-6.884 33.655-98.672 55.838z"
                    />
                </clipPath>
                <clipPath id="f">
                    <path
                        style={{
                            stroke: "#000",
                            fill: "#000",
                            transformBox: "fill-box",
                            transformOrigin: "50% 50%",
                        }}
                        transform="rotate(-15)"
                        d="m184.609 294.322-53.945 43.479 24.154 108.696-175.524-36.232-23.349-202.095z"
                    />
                </clipPath>
                <clipPath id="e">
                    <path
                        style={{
                            stroke: "#000",
                            fill: "#000",
                            transformBox: "fill-box",
                            transformOrigin: "50% 50%",
                        }}
                        transform="rotate(50)"
                        d="m135.798 174.444 46.699 73.27 5.636 35.427-43.478 1.609-15.299 28.182 8.857 39.452 41.063 55.556L45.62 472.352l-55.556-96.618 35.428-234.3z"
                    />
                </clipPath>
                <clipPath id="a">
                    <path
                        style={{
                            stroke: "#000",
                            fill: "#000",
                        }}
                        d="m608.047 28.615.764 3.825-70.37 214.171-26.772-2.295-33.655 27.536.765 38.245-58.897-.765-19.888-36.715-83.373 8.414-24.477 23.712-84.139-22.947-61.957-22.947-63.486-74.96 74.96-167.512L357.925-37.74z"
                    />
                </clipPath>
                <linearGradient
                    id="b"
                    gradientUnits="userSpaceOnUse"
                    gradientTransform="translate(.566 2.37)"
                />
                <mask id="d" maskUnits="userSpaceOnUse">
                    <path fill="#fff" d="M200 60h320v320H200z"/>
                </mask>
            </defs>
            <g
                style={{
                    clipPath: "url(#a)",
                }}
            >
                <path
                    d="M354.09 345.02c-43.368 0-84.96-16.488-115.627-45.835-30.666-29.347-47.894-69.151-47.894-110.654s17.228-81.307 47.894-110.654c30.667-29.348 72.259-45.835 115.627-45.835s84.961 16.487 115.627 45.835c30.666 29.347 47.896 69.15 47.896 110.654s-17.23 81.307-47.896 110.654-72.259 45.835-115.627 45.835Zm0 22.355c49.564 0 97.098-18.842 132.145-52.382 35.049-33.54 54.737-79.03 54.737-126.462s-19.688-92.923-54.737-126.462C451.188 28.529 403.654 9.687 354.09 9.687s-97.098 18.842-132.145 52.382-54.736 79.03-54.736 126.462 19.689 92.922 54.736 126.462 82.581 52.382 132.145 52.382Z"
                    style={{
                        stroke: "url(#b)",
                        fill: outerCircleC,
                    }}
                />
                <path
                    d="M354.09 311.486c-34.075 0-66.754-12.954-90.849-36.013s-37.632-54.332-37.632-86.943c0-32.609 13.537-63.883 37.632-86.942s56.774-36.013 90.849-36.013 66.755 12.954 90.85 36.013 37.632 54.333 37.632 86.942c0 32.611-13.537 63.885-37.632 86.943-24.095 23.059-56.774 36.013-90.85 36.013Zm0 11.178c18.407 0 36.633-3.469 53.638-10.21s32.456-16.621 45.471-29.077c13.015-12.455 23.34-27.242 30.383-43.516 7.044-16.274 10.669-33.716 10.669-51.331 0-17.614-3.625-35.056-10.669-51.33-7.043-16.274-17.368-31.061-30.383-43.516s-28.466-22.336-45.471-29.077c-17.005-6.74-35.231-10.21-53.638-10.21-37.173 0-72.823 14.132-99.108 39.287s-41.052 59.272-41.052 94.846 14.766 69.692 41.052 94.847c26.285 25.155 61.935 39.287 99.108 39.287Z"
                    style={{
                        stroke: "url(#b)",
                        fill: innerCircleC,
                    }}
                />
                <g mask="url(#mask_heart)">
                    {isCashTenant ? (
                        <>
                            <path
                                d="M424.003 198.449C416.548 185.221 392.636 171.645 366.565 181.874C346.333 189.808 341.943 204.463 340.16 207.344C337.707 211.278 332.593 210.397 332.593 210.397C335.283 202.143 335.701 192.102 334.739 184.914C333.82 177.233 333.834 170.712 334.879 164.485C335.492 160.844 336.509 157.217 338.265 153.923C338.766 152.976 343.072 146.815 344.549 147.429C349.844 149.602 354.484 150.563 361.786 149.602C365.883 149.069 373.644 147.562 375.065 146.682C376.821 145.589 377.1 144.882 377.1 144.882C377.741 140.388 375.456 137.468 375.456 137.468C375.456 137.468 382.548 136.134 384.652 130.6C385.279 128.946 382.701 125.026 381.768 123.412C378.633 117.971 374.006 110.478 369.631 106.903C367.485 105.143 360.378 101.183 350.987 106.45C337.331 114.118 318.965 122.599 296.002 175.566C289.062 191.568 285.481 223.466 285.258 232.561C284.993 243.255 287.153 254.137 316.095 259.417C337.777 263.378 353.551 263.831 379.023 263.831C386.924 263.831 414.193 261.791 424.17 243.735C433.353 227.12 430.078 209.237 424.003 198.449Z"
                                fill={largeMuscleC}/>
                            <path
                                d="M377.089 144.874C377.59 141.327 376.294 138.793 375.709 137.874L368.798 140.007C368.798 140.007 368.575 141.794 368.798 144.501C369.007 147.208 361.775 149.609 361.775 149.609C365.871 149.075 373.633 147.568 375.054 146.688C376.81 145.595 377.089 144.874 377.089 144.874ZM334.742 184.906C333.822 177.226 333.836 170.705 334.881 164.477C335.494 160.837 336.511 157.21 338.267 153.916C338.769 152.982 342.977 146.942 344.496 147.408L342.726 145.261C342.726 145.261 336.065 149.009 331.746 156.129C327.44 163.263 329.001 176.199 328.026 188.4C327.05 200.589 317.435 214.31 317.435 214.31L332.582 210.39C332.596 210.39 336.567 198.602 334.742 184.906ZM316.112 259.423C337.793 263.384 353.567 263.837 379.039 263.837C386.94 263.837 414.209 261.797 424.187 243.741C433.369 227.125 429.119 207.109 425.148 200.602C424.535 199.602 420.201 189.84 414.516 196.135C412.134 198.762 415.714 203.496 414.614 211.71C409.904 247.168 373.187 243.168 373.187 243.168C355.546 256.676 313.394 252.009 304.546 251.542C303.529 251.489 301.048 250.848 300.324 252.795C299.6 254.742 302.107 255.77 303.529 256.263C307.026 257.45 311.179 258.516 316.112 259.423Z"
                                fill={upperMuscleC}/>
                            <path
                                d="M378.953 128.345C378.535 127.292 371.902 125.772 370.091 124.932C368.196 123.998 366.705 122.251 365.868 120.704L365.938 120.531C365.952 120.477 367.903 115.157 366.273 114.477C365.381 114.103 364.712 115.183 364.545 115.637C362.259 121.611 356.518 124.158 354.874 130.826L352.018 128.745C351.21 128.159 350.736 128.358 350.471 128.625C349.426 129.719 352.561 133.026 352.603 133.052C356.672 137.28 360.88 141.64 365.492 142.08C367.624 142.294 372.432 140.92 374.048 140.427C374.341 141.574 374.424 144.667 374.341 147.001C379.273 145.481 379.12 140.907 378.103 136.626C378.103 136.626 368.544 139.827 365.604 138.253C362.831 136.987 360.225 135.786 359.125 133.973C358.511 132.959 360.42 128.959 362.636 125.612C365.52 127.038 365.98 128.292 365.799 132.332C365.673 133.333 365.381 134.853 366.161 134.866C367.318 134.999 367.986 133.146 368.182 132.106C368.293 131.572 368.906 130.079 369.408 129.639C370.592 128.598 371.777 128.932 372.334 129.038C376.542 129.746 379.552 129.999 378.953 128.345ZM314.409 223.945C313.35 225.385 311.009 224.278 311.552 222.584C311.817 221.771 312.152 220.878 312.57 219.904C314.576 215.17 318.046 209.716 323.313 208.129C332.231 205.449 332.593 210.383 332.593 210.383C324.037 213.837 318.227 218.744 314.409 223.945ZM340.633 150.588C337.916 149.081 336.369 144.334 336.369 141.347C336.369 138.36 338.265 137.28 339.128 139.88C339.992 142.48 342.027 145.241 346.026 147.828L340.633 150.588ZM359.821 237.827C360.685 236.493 362.734 237.173 363.681 237.547C369.129 239.707 380.514 244.694 394.657 238.067C413.022 229.465 413.9 213.93 413.9 213.93C414.109 211.89 414.653 211.143 416.241 211.036C418.067 210.916 418.847 212.597 418.931 214.05C419.237 220.037 419.056 236.987 398.586 245.201C379.566 252.842 365.91 244.734 361.646 241.534C360.643 240.773 358.971 239.147 359.821 237.827Z"
                                fill={innerMuscleC}/>
                        </>
                    ) : (
                        <g transform="translate(272, 132) scale(0.32)">
                            <path fill={largeMuscleC}
                                  d="M253.647 83.481c130.392-219.054 509.908 65.493-.512 372.598-514.787-328.94-101.874-598.694.512-372.598z"/>
                            <path fill={upperMuscleC}
                                  d="M344.488 10.579c146.33-39.079 316.839 185.127-65.021 429.133C561.646 215.547 470.393 36.15 344.488 10.579zM121.413.645C170.08-4.2 221.438 18.567 250.749 77.574a201.544 201.544 0 013.537 11.587c10.541 34.29.093 49.643-12.872 50.552-18.137 1.271-20.216-14.851-24.967-27.643C192.689 48.096 158.774 12.621 116.43 1.862c1.653-.434 3.315-.84 4.983-1.217z"/>
                            <path fill={innerMuscleC}
                                  d="M130.558 35.501c-42.657-4.246-87.652 23.898-99.173 66.067-7.868 25.593-.07 37.052 9.607 37.73 13.537.949 15.088-11.084 18.635-20.632 17.732-47.748 43.045-74.226 74.65-82.256a107.173 107.173 0 00-3.719-.909z"/>
                        </g>
                    )}
                </g>
            </g>
            <g
                transform="rotate(-50 103.24 278.972)scale(.95)"
                style={{
                    clipPath: "url(#e)",
                }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M98.924 268.882c-48.884 0-98.358 14.552-98.358 42.357v37.652c0 27.806 49.474 42.358 98.358 42.358s98.359-14.552 98.359-42.358v-37.652c0-27.805-49.474-42.357-98.359-42.357Zm-78.686 80.009v-11.267a101 101 0 0 0 19.671 8.095v17.706c-12.904-4.839-19.671-10.6-19.671-14.534Zm118.03 1.393v18.553c-8.528 1.685-18.363 2.918-29.508 3.37v-18.826a226 226 0 0 0 29.508-3.097Zm-49.179 21.932a195 195 0 0 1-29.508-3.37v-18.552c9.433 1.637 19.396 2.701 29.508 3.106zm68.851-8.791v-17.706a101 101 0 0 0 19.671-8.095v11.267c0 3.934-6.757 9.695-19.671 14.534Zm-59.016-28.653c-50.92 0-78.686-15.541-78.686-23.533 0-7.991 27.766-23.532 78.686-23.532s78.687 15.541 78.687 23.532c0 7.992-27.766 23.533-78.687 23.533Z"
                    style={{
                        stroke: "url(#mask_heart)",
                        fill: coin1c,
                        transformBox: "fill-box",
                        transformOrigin: "50% 50%",
                    }}
                />
            </g>
            <g
                transform="rotate(15 87.4 812.593)scale(.95)"
                style={{
                    clipPath: "url(#f)",
                }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M98.358 266.512C49.474 266.512 0 281.064 0 308.869v37.652c0 27.806 49.474 42.358 98.358 42.358s98.359-14.552 98.359-42.358v-37.652c0-27.805-49.474-42.357-98.359-42.357Zm-78.686 80.009v-11.267a100.8 100.8 0 0 0 19.671 8.095v17.706c-12.904-4.839-19.671-10.6-19.671-14.534Zm118.03 1.393v18.553c-8.528 1.685-18.363 2.918-29.508 3.37v-18.826a226 226 0 0 0 29.508-3.097Zm-49.18 21.932a195 195 0 0 1-29.507-3.37v-18.552c9.433 1.637 19.396 2.701 29.508 3.106zm68.852-8.791v-17.706a101 101 0 0 0 19.671-8.095v11.267c0 3.934-6.757 9.695-19.671 14.534Zm-59.016-28.653c-50.92 0-78.686-15.541-78.686-23.533 0-7.991 27.766-23.532 78.686-23.532s78.687 15.541 78.687 23.532c0 7.992-27.766 23.533-78.687 23.533Z"
                    style={{
                        stroke: "url(#b)",
                        fill: coin2c,
                    }}
                />
            </g>
            <g
                transform="translate(350 35)"
                color="#4e6c55"
                style={{
                    clipPath: "url(#g)",
                }}
            >
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M98.358 266.512C49.474 266.512 0 281.064 0 308.869v37.652c0 27.806 49.474 42.358 98.358 42.358s98.359-14.552 98.359-42.358v-37.652c0-27.805-49.474-42.357-98.359-42.357Zm-78.686 80.009v-11.267a100.8 100.8 0 0 0 19.671 8.095v17.706c-12.904-4.839-19.671-10.6-19.671-14.534Zm118.03 1.393v18.553c-8.528 1.685-18.363 2.918-29.508 3.37v-18.826a226 226 0 0 0 29.508-3.097Zm-49.18 21.932a195 195 0 0 1-29.507-3.37v-18.552c9.433 1.637 19.396 2.701 29.508 3.106zm68.852-8.791v-17.706a101 101 0 0 0 19.671-8.095v11.267c0 3.934-6.757 9.695-19.671 14.534Zm-59.016-28.653c-50.92 0-78.686-15.541-78.686-23.533 0-7.991 27.766-23.532 78.686-23.532s78.687 15.541 78.687 23.532c0 7.992-27.766 23.533-78.687 23.533Z"
                    style={{
                        stroke: "url(#b)",
                        fill: coin3c,
                    }}
                />
            </g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M98.358 266.512C49.474 266.512 0 281.064 0 308.869v37.652c0 27.806 49.474 42.358 98.358 42.358s98.359-14.552 98.359-42.358v-37.652c0-27.805-49.474-42.357-98.359-42.357Zm-78.686 80.009v-11.267a100.8 100.8 0 0 0 19.671 8.095v17.706c-12.904-4.839-19.671-10.6-19.671-14.534Zm118.03 1.393v18.553c-8.528 1.685-18.363 2.918-29.508 3.37v-18.826a226 226 0 0 0 29.508-3.097Zm-49.18 21.932a195 195 0 0 1-29.507-3.37v-18.552c9.433 1.637 19.396 2.701 29.508 3.106zm68.852-8.791v-17.706a101 101 0 0 0 19.671-8.095v11.267c0 3.934-6.757 9.695-19.671 14.534Zm-59.016-28.653c-50.92 0-78.686-15.541-78.686-23.533 0-7.991 27.766-23.532 78.686-23.532s78.687 15.541 78.687 23.532c0 7.992-27.766 23.533-78.687 23.533Z"
                style={{
                    stroke: "url(#b)",
                    fill: coin4c,
                }}
                transform="rotate(-25 235.912 -204.862)"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M98.358 266.512C49.474 266.512 0 281.064 0 308.869v37.652c0 27.806 49.474 42.358 98.358 42.358s98.359-14.552 98.359-42.358v-37.652c0-27.805-49.474-42.357-98.359-42.357Zm-78.686 80.009v-11.267a100.8 100.8 0 0 0 19.671 8.095v17.706c-12.904-4.839-19.671-10.6-19.671-14.534Zm118.03 1.393v18.553c-8.528 1.685-18.363 2.918-29.508 3.37v-18.826a226 226 0 0 0 29.508-3.097Zm-49.18 21.932a195 195 0 0 1-29.507-3.37v-18.552c9.433 1.637 19.396 2.701 29.508 3.106zm68.852-8.791v-17.706a101 101 0 0 0 19.671-8.095v11.267c0 3.934-6.757 9.695-19.671 14.534Zm-59.016-28.653c-50.92 0-78.686-15.541-78.686-23.533 0-7.991 27.766-23.532 78.686-23.532s78.687 15.541 78.687 23.532c0 7.992-27.766 23.533-78.687 23.533Z"
                style={{
                    stroke: "url(#b)",
                    fill: coin5c,
                }}
                transform="rotate(45 333.358 876.21)"
            />
        </svg>
    );

export const ShadowCoinyLogo = (props) => (
    <svg width={props.width} height={props.height} viewBox="-2 -2 200 200">
        <defs>
            <filter id="drop">
                <feDropShadow dx="0" dy="0" stdDeviation="2" floodColor="#ffffff"/>
            </filter>
        </defs>

        {/* move UP */}
        <g filter="url(#drop)" transform={`translate(-4, ${props.showLetters ? 12 : 35})`}>
            <CoinyLogo {...props} width={196} height={(196 / 659) * 470}/>
        </g>

        {/* move DOWN */}
        {props.showLetters && (
            <g filter="url(#drop)" transform="translate(0, 140)">
                <LogoText {...props} width={196} height={(196 / 659) * 470}/>
            </g>
        )}
    </svg>
);


export default CoinyLogo;
